import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import throttle from 'lodash/throttle';
const defaultProps = {
    offsetTop: 0
};
const THROTTLE_TIMEOUT = 300;
var _React_Component;
class OnScrollToElement extends (_React_Component = React.Component) {
    render() {
        return null;
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleOnScrollToElement);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleOnScrollToElement);
    }
    getTopVisibleElement() {
        const { offsetTop, elements } = this.props;
        const topVisibleElement = elements.find((elem)=>{
            if (elem instanceof HTMLElement) {
                const { top, height } = elem.getBoundingClientRect();
                return top + height - offsetTop > 0;
            }
            return false;
        });
        if (topVisibleElement) {
            return topVisibleElement;
        }
        return elements[elements.length - 1];
    }
    constructor(...args){
        super(...args);
        _define_property(this, "current", void 0);
        _define_property(this, "handleOnScrollToElement", throttle(()=>requestAnimationFrame(()=>{
                const { onScrollTo } = this.props;
                const topVisibleElement = this.getTopVisibleElement();
                if (this.current !== topVisibleElement) {
                    this.current = topVisibleElement;
                    onScrollTo(topVisibleElement);
                }
            }), THROTTLE_TIMEOUT, {
            leading: false
        }));
    }
}
_define_property(OnScrollToElement, "defaultProps", defaultProps);
export default OnScrollToElement;

//# sourceMappingURL=OnScrollToElement.js.map